module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAARCAYAAADZsVyDAAABDklEQVQ4T63UMU7CUBzH8e+vg6ObHgFj4hEEJo8ArnoHF1ATYmIZOISuwBGYClcgxjPg6uTw/qYtGtHX9tnSrcP75p9P/30CsGH3HtwN6DB9r/2Id5wmGicPssF5C0WvgGoHfx80dyK765zieNlbNA1FtLIpbdiZAv09xWeKl5d5eNA+Aq0Rx43ixgbsTOPV27er3XZ7mM0ahaW+HpN52tj5YA1JMoKvwXbDKUmkNfZPErHB5QTecOZdh+QHQWF4uyWpdS/Qe654+WejvD9FtiUhJB6C0omDSTwEleEAEi9BWLiIpIQgKFxIUkIQHN5eq09gV/khPStOrqs2JuiqtBERH+2LLHawWmiEqwp/Amz8b8r5j+hZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_detail_eight_down.png
// module id = X21x
// module chunks = 0